import { useMemo, useState } from "react";

import AppButton from "../../../../commons/buttons/AppButton";
import AppLinkButton from "../../../../commons/buttons/AppLinkButton";
import CompanyAPI from "../../../company/CompanyAPI";
import HallAppToast from "../../../../commons/HallAppToast";
import PromotionAPI from "../../PromotionAPI";
import { formatDate } from "../../../../commons/util/HallAppUtil";

// TODO: trocar por PromotionAPI real


const promotionAPI = new PromotionAPI();
const companyAPI = new CompanyAPI();

const WEEK_LABEL = {
  SUNDAY: "Domingo",
  MONDAY: "Segunda-feira",
  TUESDAY: "Terça-feira",
  WEDNESDAY: "Quarta-feira",
  THURSDAY: "Quinta-feira",
  FRIDAY: "Sexta-feira",
  SATURDAY: "Sábado",
};


function PromotionStep4({ data, toBack, closeModal, onSaved,promotionId }) {
  const [loading, setLoading] = useState(false);

  const daysLabel =
    data?.validWeeks?.length
      ? data.validWeeks.map((k) => WEEK_LABEL[k] || k).join(", ")
      : "—";

  const summary = useMemo(() => {
    const servicesCount = data?.serviceIds?.length || 0;
    return {
      name: data?.name || "—",
      description: data?.description || "—",
      validity:
        data?.noEndDate
          ? "Até desativar"
          : [formatDate(data?.startDate), formatDate(data?.endDate)].filter(Boolean).join(" até ") || "—",
      active: data?.active ? "Ativa" : "Inativa",
      servicesCount,
      discount:
        data?.discountType === "PERCENT"
          ? `${data?.discountValue || "—"}%`
          : data?.discountType === "FIXED"
            ? `Desconto de R$ ${data?.discountValue || "—"}`
            : `Preço final: R$ ${data?.discountValue || "—"}`,
      showToClients: data?.showToClients ? "Sim" : "Não",
      highlightAgenda: data?.highlightAgenda ? "Sim" : "Não",
      limits: `Total: ${data?.limitTotalUses || "—"} | Por cliente: ${data?.limitPerCustomer || "—"}`,
      scheduleRule: `Dias: ${daysLabel} | Horário: ${[data?.startHour, data?.endHour].filter(Boolean).join(" - ") || "—"
        }`,
    };
  }, [data]);



  const save = async () => {
    try {
      setLoading(true);
  
      const payload = {
        ...data,
  
        // normalizações básicas
        name: String(data?.name || "").trim(),
        description: String(data?.description || "").trim(),
        companyId: companyAPI.getCompanyManagment().id,
  
        // garante booleanos
        active: data?.active ?? true,
        showToClients: Boolean(data?.showToClients),
        highlightAgenda: Boolean(data?.highlightAgenda),
  
        // noEndDate coerente
        noEndDate: Boolean(data?.noEndDate),
  
        // horas (backend aceita "", null, HH:mm)
        startHour: data?.startHour || "",
        endHour: data?.endHour || "",
  
        // arrays seguros
        validWeeks: Array.isArray(data?.validWeeks) ? data.validWeeks : [],
        employeeServices: Array.isArray(data?.employeeServices) ? data.employeeServices : [],
      };
  
      if (promotionId) {
        // 🔵 UPDATE
        await promotionAPI.update(promotionId, payload);
        HallAppToast.success("Promoção atualizada com sucesso!");
      } else {
        // 🟢 CREATE
        await promotionAPI.create(payload);
        HallAppToast.success("Promoção criada com sucesso!");
      }
  
      onSaved?.();
      closeModal?.();
    } catch (e) {
      HallAppToast.genericError();
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div>
      <div className="mb-3">
        <div style={{ fontSize: 16, fontWeight: 700, lineHeight: "20px" }}>
          Revisão
        </div>
        <div className="text-muted" style={{ fontSize: 12 }}>
          Confira antes de salvar.
        </div>
      </div>

      <div className="card-step">
        <div className="review-row"><b>Nome:</b> {summary.name}</div>
        <div className="review-row"><b>Descrição:</b> {summary.description}</div>
        <div className="review-row"><b>Validade:</b> {summary.validity}</div>
        <div className="review-row"><b>Status:</b> {summary.active}</div>
      </div>

      <div className="card-step mt-3">
        <div className="review-row"><b>Serviços:</b> {summary.servicesCount} selecionado(s)</div>
        <div className="review-row"><b>Promoção:</b> {summary.discount}</div>
      </div>

      <div className="card-step mt-3">
        <div className="review-row"><b>Exibir para clientes:</b> {summary.showToClients}</div>
        <div className="review-row"><b>Destacar na agenda:</b> {summary.highlightAgenda}</div>
        <div className="review-row"><b>Limites:</b> {summary.limits}</div>
        <div className="review-row"><b>Regras:</b> {summary.scheduleRule}</div>
      </div>

      <div className="sticky-footer">
        <AppLinkButton
          name={loading ? "Salvando..." : "Salvar promoção"}
          fullWidth
          disabled={loading}
          onClick={save}
        />
        <div style={{ marginTop: 10 }}>
          <AppButton name="Voltar" width="100%" onClick={toBack} disabled={loading} />
        </div>
      </div>
    </div>
  );
}

export default PromotionStep4;
